import withFeatureBranch from '@wix/da-react-context/pkg/flags/withFeatureBranch';
import { default as DeviationFlags } from './DeviationFlags';
import { default as DeviationFlagsBranched } from './DeviationFlags.dd_and_hype_banners';
export default withFeatureBranch({
    dd_and_hype_banners: DeviationFlagsBranched
})(DeviationFlags);
